<h4 *ngIf="!edit">Créer un nouvel utilisateur</h4>
<h4 *ngIf="edit">Modification utilisateur /{{item.login}}/{{item.id}}/</h4>
<form (ngSubmit)="save()" #userForm="ngForm">
    <div>
        <div class="p-grid" >
            <div class="p-fluid p-field p-md-4">
                <label for="login">Login *</label>
                <input type="text" size="30" pInputText name="login" id="login"
                       [required]="true" minlength="8" pattern="[a-zA-Z][a-zA-Z0-9]*" 
                       [readonly]="edit"
                       maxlength="25" autocomplete="off" [(ngModel)]="item.login"> 
                <small class="p-invalid" *ngIf="!userForm.controls['login']?.valid&&userForm.controls['login']?.dirty">{{userForm.controls['login'].errors['required'] ? 'login is required' : userForm.controls['login'].errors['minlength'] ? 'Must be longer than 8 characters' : ''}}</small>

            </div>
            <div class="p-fluid p-field p-md-4">
                <label for="name">Nom *</label>
                <input type="text" size="30" pInputText name="name" id="name"
                       [required]="true" maxlength="150" autocomplete="off" [(ngModel)]="item.name"> 
                <p-message severity="error" 
                           [text]="userForm.controls['name'].errors['required'] ? 'name is required' : userForm.controls['name'].errors['maxlength'] ? 'Must be smaller than 150 characters' : ''"
                           *ngIf="!userForm.controls['name']?.valid&&userForm.controls['name']?.dirty"></p-message>
            </div>
            <div class="p-fluid p-field p-md-4">
                <label for="float-input">Email *</label>
                <input type="email" size="30" pInputText name="email"
                       [required]="true" maxlength="150" autocomplete="off" [(ngModel)]="item.email"> 
                <p-message severity="error" 
                           [text]="userForm.controls['email'].errors['required'] ? 'email is required' : userForm.controls['email'].errors['maxlength'] ? 'Must be smaller than 150 characters' : ''"
                           *ngIf="!userForm.controls['email']?.valid&&userForm.controls['email']?.dirty"></p-message>
            </div>
            <div class="p-fluid p-field p-md-4">
                <label for="float-input">Password</label>
                <input type="password" size="30" pPassword  name="password1"
                       [required]="!edit" maxlength="150" minlength="8" autocomplete="off" [(ngModel)]="item.password"> 

                <p-message severity="error" 
                           [text]="userForm.controls['password1'].errors['required'] ? 'password is required' : userForm.controls['password1'].errors['minlength'] ? 'Must be longer than 8 characters' : ''"
                           *ngIf="!userForm.controls['password1']?.valid&&userForm.controls['password1']?.dirty"></p-message>
            </div>
            <div class="p-fluid p-field p-md-4">
                <label for="float-input">Confirm Password</label>
                <input type="password" size="30" pPassword  name="password2"
                       [required]="!edit" maxlength="150" minlength="8" autocomplete="off" [(ngModel)]="password"> 

                <p-message severity="error" 
                           [text]="userForm.controls['password2'].errors['required'] ? 'confirm password is required' : userForm.controls['password2'].errors['minlength'] ? 'Must be longer than 8 characters' : ''"
                           *ngIf="!userForm.controls['password2']?.valid&&userForm.controls['password2']?.dirty"></p-message>
            </div>
            <div class="p-fluid p-field p-md-4">
                <label>User Group</label>
                <p-dropdown placeholder="Select a Group"   [required]="true"  [options]="groupKeys" name="group" [(ngModel)]="item.group"  ></p-dropdown>
                <p-message severity="error" 
                           [text]="userForm.controls['group'].errors['required'] ? 'group is required' : ''"
                           *ngIf="!userForm.controls['group']?.valid&&userForm.controls['group']?.dirty"></p-message>
            </div>
            <div class="p-fluid p-field p-md-4">
                <div><label>Roles *</label></div>
                <p-listbox [listStyle]="{'height':'150px'}" name="roleIds" [options]="roles" 
                           [(ngModel)]="item.roleIds" optionLabel="name" 
                           filter="filter" multiple="true" checkbox="true" dataKey="id">                       
                    <p-footer>
                            <div class="p-col p-col-fixed">
                                <p-tag *ngFor="let u of item.roleIds" styleClass="p-mr-2" [value]="u.name"></p-tag>
                            </div>
                        </p-footer>
                </p-listbox>
            </div>
            <div class="p-fluid p-field p-md-4">
                <p-checkbox class="p-mt-5" name="reInitPassword" label="Reinit password"  binary="true"  [(ngModel)]="item.reInitPassword" ></p-checkbox>
            </div>
            <div class="p-fluid p-field p-md-4">
                <p-checkbox class="p-mt-5" name="active" label="Active" [(ngModel)]="item.active" binary="true" ></p-checkbox>

            </div>
        </div>
        <div class="ui-g">
            <div class="ui-g-4">
                <button pButton [disabled]="!userForm.valid" type="submit" label="Validate" icon="pi pi-check" iconPos="left" style="margin-right: 0.5em;" class="p-button-success"></button>
                <button pButton routerLink="/admin/users"  type="button" label="Cancel"  icon="pi pi-times" iconPos="left" style="margin-right: 0.5em;" class="p-button-danger"></button>
            </div>
        </div>
    </div>
</form>